type TrackingEventsFlags = {
	legacySuccess?: boolean;
	intent?: boolean;
	cancel?: boolean;
	failure?: boolean;
};

type TrackingEvents<F extends TrackingEventsFlags> = { success: string } & (F['legacySuccess'] extends true
	? { legacy_success: string }
	: unknown) &
	(F['intent'] extends true ? { intent: string } : unknown) &
	(F['cancel'] extends true ? { cancel: string } : unknown) &
	(F['failure'] extends true ? { failure: string } : unknown);

export function buildTrackingEvents<const F extends TrackingEventsFlags>(
	trackingEventName: string,
	flags?: F,
): TrackingEvents<F> {
	const { legacySuccess, intent, cancel, failure } = flags ?? {};
	return {
		success: legacySuccess ? `${trackingEventName}_success` : trackingEventName,
		...(legacySuccess ? { legacy_success: trackingEventName } : {}),
		...(intent ? { intent: `${trackingEventName}_intent` } : {}),
		...(cancel ? { cancel: `${trackingEventName}_cancel` } : {}),
		...(failure ? { failure: `${trackingEventName}_failure` } : {}),
	} as TrackingEvents<F>;
}
